import Embed from '@editorjs/embed';
import Header from '@editorjs/header';
import ImageTool from '@editorjs/image';
import List from '@editorjs/list';
import Color from 'editorjs-text-color-plugin';
import Hyperlink from 'editorjs-hyperlink';
import RawTool from '@editorjs/raw';
import { StyleInlineTool} from 'editorjs-style';
import AnyButton from 'editorjs-button';
import Tooltip from 'editorjs-tooltip';
import { tusUploader } from '..';


export const EDITOR_TOOLS = {
  tooltip: {
    class: Tooltip,
    config: {
      location: 'left',
      highlightColor: '#FFEFD5',
      underline: true,
      backgroundColor: '#154360',
      textColor: '#FDFEFE',
      holder: 'editorId',
    }
  },
  AnyButton: {
    class: AnyButton,
    inlineToolbar: false,
    config:{
      css:{
        "btnColor": "btn--gray",
      }
    }
  },
  style: StyleInlineTool,
  raw: RawTool,
  hyperlink: {
    class: Hyperlink,
    config: {
      shortcut: 'CMD+L',
      target: '_blank',
      rel: 'nofollow',
      availableTargets: ['_blank', '_self'],
      validate: false
    }
  },
  Color: {
    class: Color, // if load from CDN, please try: window.ColorPlugin
    config: {
      colorCollections: ['#E21F26'],
      defaultColor: '#E21F26',
      type: 'text', 
    }     
  },
  embed: {
    class: Embed,
    config: {
      services: {
        youtube: true
      }
    }
  },
  list: List,
  image: {
    class: ImageTool,
    config: {
      buttonContent: 'Selecione uma imagem para fazer upload',
      captionPlaceholder: 'Adicione uma legenda ou um link',
      uploader: {
        uploadByFile: async (file: File) => {
          try {
            const image = await tusUploader(file);
            return { success: true, file: image };
          } catch (error) {
            return { success: false };
          }
        },
        uploadByUrl: async (url: string) => {}
      }
    }
  },
  header: {
    class: Header,
    config: {
      levels: [1, 2, 3]
    }
  }
};
